export const initFocus = () => {
    document.querySelector<HTMLInputElement>('main h1')?.focus()
};
